function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "chat"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 2h-14c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h4.382l1.724 3.447c.169.339.515.553.894.553s.725-.214.895-.553l1.723-3.447h4.382c1.654 0 3-1.346 3-3v-10c0-1.654-1.346-3-3-3zm1 13c0 .551-.448 1-1 1h-5c-.379 0-.725.214-.895.553l-1.105 2.211-1.105-2.211c-.17-.339-.516-.553-.895-.553h-5c-.552 0-1-.449-1-1v-10c0-.551.448-1 1-1h14c.552 0 1 .449 1 1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 10,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 10,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 10,
  r: 1
})));

var Svg025Comment = function Svg025Comment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg025Comment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/025-comment.b49985a4.svg";
export { ForwardRef as ReactComponent };